import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search, AlertCircle } from 'lucide-react';
import { Page } from './Page';

export const InternalNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Page>
      <div className="flex items-center justify-center min-h-[calc(100vh-200px)] px-4">
        <div className="text-center max-w-2xl mx-auto">
          {/* Icon and 404 */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="w-24 h-24 bg-indigo-100 rounded-full flex items-center justify-center">
                <Search className="h-12 w-12 text-indigo-600" />
              </div>
              <div className="absolute -top-1 -right-1 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                <AlertCircle className="h-5 w-5 text-red-600" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="bg-white rounded-lg shadow-sm p-8 md:p-12 border border-gray-200">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              404
            </h1>
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">
              Page Not Found
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              The page you're looking for doesn't exist or has been moved.
              Please check the URL or navigate back to your sessions.
            </p>

            {/* Action buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/panel/sessions')}
                className="flex items-center justify-center px-6 py-3 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition-colors duration-200 shadow-sm hover:shadow-md"
              >
                <Home className="h-5 w-5 mr-2" />
                Go to Sessions
              </button>
              <button
                onClick={() => navigate(-1)}
                className="flex items-center justify-center px-6 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors duration-200 shadow-sm hover:shadow-md"
              >
                <ArrowLeft className="h-5 w-5 mr-2" />
                Go Back
              </button>
            </div>

            {/* Helpful links */}
            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-gray-600 mb-4">Quick links:</p>
              <div className="flex flex-wrap justify-center gap-4 text-sm">
                <button
                  onClick={() => navigate('/panel/sessions')}
                  className="text-indigo-600 hover:text-indigo-800 underline underline-offset-4 decoration-indigo-300 hover:decoration-indigo-600 transition-colors"
                >
                  Sessions
                </button>
                <button
                  onClick={() => navigate('/panel/profile')}
                  className="text-indigo-600 hover:text-indigo-800 underline underline-offset-4 decoration-indigo-300 hover:decoration-indigo-600 transition-colors"
                >
                  Profile & Billing
                </button>
                <button
                  onClick={() => navigate('/')}
                  className="text-indigo-600 hover:text-indigo-800 underline underline-offset-4 decoration-indigo-300 hover:decoration-indigo-600 transition-colors"
                >
                  Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};
